import { Spin } from 'antd'
import React, { DetailedHTMLProps } from 'react'
import styles from './PageSpinner.module.scss'
import cn from 'classnames'
import { IconRadiation } from '../../../utils/icons'

const loadIcon = <IconRadiation width='44' height='44' fill='var(--color-main)' />

const PageSpinner: React.FC<
  DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ className, ...props }) => {
  return (
    <div {...props} className={cn(styles.container, className)}>
      <Spin indicator={loadIcon} className='spinner' />
    </div>
  )
}

export default PageSpinner
